import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { getCurrencyFormat, getIsAppRebrandActive } from '../../selectors/app';
import { getCurrency, getFormattedEventDate } from '../../selectors/event';
import { getUnformattedOrderCost } from '../../selectors/order/getUnformattedOrderCost';
import { getIsPaymentView } from '../../selectors/routing';
import { getTicketsProps } from '../../selectors/tickets/getTicketsProps';
import { CheckoutState } from '../../state';
import { OrderNamespace } from '../../state/order';
import { CartSummaryProps } from './CartSummary';

const _mapStateToProps = (
    state: CheckoutState & {
        order: OrderNamespace;
    },
): Partial<CartSummaryProps> => ({
    currency: getCurrency(state),
    currencyFormat: getCurrencyFormat(state),
    ticketQuantity: getTicketsProps(state).totalTicketQuantity,
    totalCost: getUnformattedOrderCost(state),
    isAppRebrandActive: getIsAppRebrandActive(state),
    isCheckoutPage: getIsPaymentView(state),
    eventDate: getFormattedEventDate(state),
});

const _mapDispatchToProps = <Action>(
    _dispatch: Dispatch<Action>,
): Partial<
    Omit<CartSummaryProps, keyof ReturnType<typeof _mapStateToProps>>
> => ({});

export type ConnectedProps = ReturnType<typeof _mapStateToProps> &
    ReturnType<typeof _mapDispatchToProps>;

export const connectCartSummary = connect(
    _mapStateToProps,
    _mapDispatchToProps,
);
